@use '@/styles/tokens' as *;

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-6) var(--space-5) var(--space-5);
  background: var(--surface-muted, #{$color-neutral-100});
  border: 1px solid transparent;
  border-radius: 16px;
  cursor: pointer;
  text-align: center;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.15s ease;

  &:hover {
    border-color: $color-neutral-200;
    box-shadow: 0 6px 20px rgb(0 0 0 / 6%);
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: none;
    border-color: var(--brand-500, #{$color-brand-700});
    box-shadow: 0 0 0 3px var(--focus-ring, rgb(120 140 40 / 25%));
  }
}

.open {
  position: absolute;
  top: var(--space-4);
  right: var(--space-4);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--text-secondary);
  background: var(--surface, #fff);
  border-radius: 50%;
}

.unreadDot {
  position: absolute;
  top: var(--space-4);
  left: var(--space-4);
  width: 10px;
  height: 10px;
  background: var(--status-warning, #e8833a);
  border-radius: 50%;
}

.flag {
  position: absolute;
  top: var(--space-4);
  left: var(--space-4);
  padding: 2px 8px;
  font-size: 10px;
  font-weight: var(--font-weight-medium);
  border-radius: 24px;
}

.flagAction {
  color: $color-stage-attention-text;
  background: $color-error-100;
}

.imageWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 132px;
}

.image {
  max-width: 70%;
  max-height: 132px;
  object-fit: contain;
}

.imageFallback {
  width: 120px;
  height: 110px;
  background: $color-neutral-200;
  border-radius: 12px;
}

.chipRow {
  display: flex;
  justify-content: center;
}

.name {
  font-size: 16px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.updated {
  font-size: 12px;
  color: var(--text-muted);
}
